import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CarrierService } from "app/services/carrier.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CarrierDriverService } from "../service/carrier-driver.service";
import { DocumentsServiceService } from "app/services/documents-service.service";

@Component({
  selector: "app-carrier-driver-details",
  templateUrl: "./carrier-driver-details.component.html",
  styleUrls: ["./carrier-driver-details.component.scss"],
})
export class CarrierDriverDetailsComponent implements OnInit {
  @Input() driverDetails: any;
  driverId: any;
  @Input() carrierId: any;
  @Output() saved = new EventEmitter();
  isLoading: boolean = true;
  carrierDetails: any = [];
  branches: any = [];
  viewDocuments: any;
  pdfSrc: string;
  constructor(
    private _carrierDepotService: CarrierDriverService,
    private _carrierInfo: CarrierService,
    private _route: Router,
    private confirmDialogService: ConfirmDialogService,
    private toastService: ToastNotificationService,
    private documentService: DocumentsServiceService,
  ) {
    
  }

  ngOnInit(): void {
    if (this.carrierId){
      this.getCarrierInfo();
      this.getCarrierExistingDocuments()
    } 
  }

  getCarrierInfo() {
    this.isLoading = true;
    this._carrierInfo
      .getCompanyDetailsById(this.carrierId)
      .subscribe((res: any) => {
        if (res) this.carrierDetails = res.Carrier;
        if (res && res.Branches) this.branches = res.Branches;
        this.isLoading = false;
      });
  }

  getDriverDetails() {
    this.isLoading = true;
    this._carrierDepotService
      .getDriverDetails(this.driverId)
      .subscribe((res: any) => {
        if (res) {
          this.driverDetails = res;
          this.isLoading = false;
        }
      });
  }

  onDeleteDriver(driver) {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to delete this driver information?",
      () => {
        this.isLoading = true;

        this._carrierDepotService.delete(driver.id).subscribe(
          (data) => {
            this.toastService.success(
              "The driver information was deleted successfully",
              "success"
            );
          },
          (error) => {
            this.isLoading = false;
            this.toastService.error(
              "Your request could not be processed succesfully.Please contact the system admin if the problem persists.",
              "error"
            );
          }
        );
      },
      () => {
        return false;
      }
    );
  }

  back () {
    this.saved.emit('true');
  }
  getCarrierExistingDocuments() {
    this.isLoading = true;
    this.documentService.getByCarrierId(this.carrierId).subscribe(
      (result:any) => {
        console.log(result);
        if(this.driverDetails.id_type_ind ==  1){
          this.viewDocuments = result.filter(x => x.notes === this.driverDetails.id_number);
          
        }
        if(this.driverDetails.id_type_ind == 2){
          this.viewDocuments = result.filter(x => x.notes === this.driverDetails.passport_number);
        }
        if (this.viewDocuments.length > 0) {
          // this.removeUploadedDocTypes();
        }
      },
      (error) => {
        this.viewDocuments = [];
  
        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier documents.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      }
    );
  }
  viewDoc(id, fileName) {

    id = fileName.substring(fileName.indexOf("#") + 1);
    this.pdfSrc = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes(".pdf")) {
      this.documentService.downloadpdf(id).subscribe((x) => {
        console.log(x);
  
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;
  
        //alert(this.pdfSrc.toString());
        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoading = false;
      });
      return;
    }

  }
}
